import { LoadingButton } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import api from '~/services/api';
import { storeState } from '~/store';
import { buildPdfBlobFromApiResponse, triggerPdfDownload } from '~/utils/downloadPdf';
import arideSuccess from '../../../../assets/images/aride-success.png';
import { purpleText } from '../styles';

export function RenewalSuccess() {
  const { contractId } = useParams();
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get('org') ?? undefined;

  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);

      const url =
        organizationId != null
          ? `/Contracts/${contractId}/download?organization_id=${encodeURIComponent(organizationId)}`
          : `/Contracts/${contractId}/download`;
      const response = await (api.v2 ?? api).get(url, { responseType: 'arraybuffer' });
      const blob = buildPdfBlobFromApiResponse(response.data);
      triggerPdfDownload(blob, 'contrato.pdf');

      storeState.addToast({ type: 'success', title: 'Sucesso!', message: 'Download finalizado com sucesso!' });
    } catch (e) {
      storeState.addToast({
        type: 'error',
        title: 'Algo deu errado!',
        message: 'Não foi possível fazer o download do contrato, tente novamente mais tarde!'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        paddingTop: '8rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
        maxWidth: 520
      }}
    >
      <img width={200} src={arideSuccess} />
      <Typography variant="h3" fontSize={24} fontWeight="bold" paddingTop="1rem" textAlign="center">
        Pagamento aprovado!
      </Typography>
      <Typography
        variant="h1"
        sx={{
          ...purpleText,
          fontSize: 36,
          fontWeight: 500,
          padding: 2
        }}
      >
        Renovado
      </Typography>
      <Typography variant="subtitle2" fontSize={20} textAlign="center" fontWeight="300">
        Seus dados foram aprovados! Estamos muito felizes por continuar sendo nosso cliente!
      </Typography>

      <LoadingButton
        variant="contained"
        onClick={handleDownload}
        disabled={isLoading}
        sx={{ minWidth: '60%', marginTop: 2 }}
        loading={isLoading}
      >
        Baixar contrato
      </LoadingButton>
    </Box>
  );
}
